module.exports = __webpack_public_path__ + "static/img/gzh_ewm.4b4c9f79.svg";